import React from 'react';
import { Typography } from 'antd';
import { createHouseAddress } from '../../../../../shared/packages/address';

const ParentList = ({ roomData }) => {
  return (
    <div>
      <Typography.Text>
        {roomData.typeName} {roomData.flat}{' '}
        <Typography.Text type="danger">(удалится вся связка)</Typography.Text>
      </Typography.Text>

      <ul>
        {roomData.relatedRooms.map((room) => {
          return (
            <li key={room.id}>
              {room.typeName} {room.flat}{' '}
              {room.houseId !== roomData.houseId && (
                <Typography.Text type="secondary">
                  ({createHouseAddress(room)})
                </Typography.Text>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ParentList;
